import React, { useState, useEffect, useRef } from 'react'
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'

import {
    AppLayout, HelpPanel, Icon, BreadcrumbGroup, Box, Table, SpaceBetween, Header, Button,
    Container, Spinner, Pagination, Alert,  Modal, Link
} from '@amzn/awsui-components-react';
import SideNav from './SideNav';
import AccessDenied from '../../AccessDenied'
import WaitForPageAccess from '../../WaitForPageAccess'
import './history.scss'
import checkPageAccess, { checkIfPortalAdmin, checkIfSupportAdmin } from "../../checkPageAccess";
import { API, graphqlOperation } from 'aws-amplify';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useAuth } from "../../context/AuthContextProvider";
import { Storage } from 'aws-amplify';
import { setCurrentAppId } from '../../store/userAuthSlice';
import moment from 'moment';
import { PROCESS_KEYS } from './Constants';
import { configureLogicoS3, configureGenericS3, configureGenericAppSync } from 'src/context/AuthContextUtility'
import { isApprover, isUploaderAllowed } from './AccessUtilities';
import { getLogicoTransactionsByLogicoProcessId } from "src/Ateam-BI/Templates/Utils/AppActivityUtils"
import { getLogicoProcessById } from "src/Ateam-BI/Templates/Utils/AppActivityUtilsAppsyncPlus"
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"
import { getDocumentFromVault } from 'src/Ateam-BI/Vault/VaultAPIs';
import { VAULT_SERVICES } from 'src/Ateam-BI/Vault/constants';

const LogicoHistory = (props) => {
    const userAuthenticationDetails = useAuth();
    const gridRef = useRef();
    const history = useHistory();
    const dispatch = useDispatch()
    const [isCheckingAccess, setIsCheckingAccess] = useState(true);
    const [isAuthorised, setIsAuthorised] = useState(false);
    const [showLoadingIcon, setShowLoadingIcon] = useState(true);
    const [processData, setProcessData] = useState({})
    const [transactions, setTransactions] = useState([])
    const [loadErrorData, setLoadErrorData] = useState([])
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const userId = useSelector((globalState) => globalState.auth.userId);
    const [visible, setVisible] = useState(false)
 
    let { id: paramId } = useParams();
    let { lpid: paramLpid } = useParams();
    
    const id = props.id || paramId;
    const lpid = props.lpid || paramLpid;
    const [backUrl, setBackUrl] = useState(null)


    const ln = useLocation()
    useVisibleTimeTracker([{
            metricName : 'actionPerformedBy',
            metricValue : userId,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        },
        {
            metricName : 'pagePath',
            metricValue : `${ln.pathname}`,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        }
        ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.LOGICO);
    useEffect(() => {
        configureLogicoS3()
        if (lpid) {
            loadData()
        }
        setBackUrl(getParam('back'))
        if(id){
            dispatch(setCurrentAppId(id))
        }
        return () => {
            configureGenericS3()
        };
    }, []);


    const processIcon = props => (
        props.data.status === 'Completed' ?
            <Box>
                <Icon name='status-positive' variant='success' ></Icon>
            </Box>

            : <Box>
                <Icon name='status-in-progress' variant='normal' ></Icon>
            </Box>


    )

    const downloadFile = async (item) => {
        setShowLoadingIcon(true)
        // configureLogicoS3()
        let fn = `${item.filePath}`
        // fn = fn.replace('logico/','')
        // let prefix = 'logico/'
        // const result = await Storage.get(fn, { level: 'public', customPrefix:{public:prefix}, expires: 60 });
        const contentType = fn?.split(".")[1]
        let result = await getDocumentFromVault(contentType, VAULT_SERVICES.LOGICO, {"file_path": `${fn}`,"service_id":`${lpid}`, "app_id":`${id}`})
        let fileURL = result?.fileUrl
        window.open(fileURL);
        setShowLoadingIcon(false)
    }

    const downloadIcon = props => (
        <SpaceBetween size='m' direction='horizontal'>
        <Button
            variant='inline-icon'
            iconName='download'
            onClick={() => {
                downloadFile(props.data)
            }
            }></Button>
        </SpaceBetween>
        
    )

    const epochToTimestamp = props => (
        <Box>{ moment(new Date(Number(props.data.uploadedTimeStamp))).format()   }</Box>
    )

    const approvalStatusButton = (props) => {
        if (props?.data.approvalStatus == 'pending') {
            return  <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='orange_badge' >{props.data.approvalStatus}</span> </Link>
          } else if (props.data.approvalStatus == 'completed') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='green_badge' >{props.data.approvalStatus}</span> </Link>
          } else if (props.data.approvalStatus == 'rejected') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='red_badge' >{props.data.approvalStatus}</span> </Link>
          } else if (props.data.approvalStatus == 'cancelled') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='grey_badge' >{props.data.approvalStatus}</span> </Link>
          } else if (props.data.approvalStatus == 'NO APPROVAL') {
            return  <span className='blue_badge' >{props.data.approvalStatus}</span> 
          } else {
            if(props.data.approvalId){
                return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='blue_badge' >{props.data.approvalStatus}</span> </Link>
            }else{
                return <span className='blue_badge' >{props.data.approvalStatus}</span>
            }
          }
    }
    

    const processImg = (props) => (
        <Box float="left">
          <img
            alt=""
            className="rounded-circle"
            src={
              "https://badgephotos.corp.amazon.com/?uid=" +
              props.data.uploadedBy
            }
            width={20}
            height={20}
          />
          &nbsp;
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={"https://phonetool.amazon.com/users/" + props.data.uploadedBy}
          >
            {props.data.uploadedBy}
          </a>
        </Box>
      );

    const  processImgApprovedBy = (props) => (
            props.data.approvedBy ? <Box float="left">
              <img
                alt=""
                className="rounded-circle"
                src={
                  "https://badgephotos.corp.amazon.com/?uid=" +
                  props.data.approvedBy
                }
                width={20}
                height={20}
              />
              &nbsp;
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={"https://phonetool.amazon.com/users/" + props.data.approvedBy}
              >
                {props.data.approvedBy}
              </a>
            </Box> : <Box></Box>
        );


    const [columnDefs] = useState([
        { field: 'fileId', width: 300,  headerName: 'file id',sortable: true, resizable: true },
        { field: 'status', width: 200, headerName: 'Status', sortable: true, resizable: true },
        { field: 'uploadedBy', width: 150, headerName: 'Uploaded by', cellRenderer:processImg, sortable: true, resizable: true },
        { field: 'approvalStatus', width: 200, headerName: 'Approval status', sortable: true, cellRenderer:approvalStatusButton , resizable: true },
         { field: 'approvedBy', width: 150, headerName: 'Approved by', cellRenderer:processImgApprovedBy, sortable: true, resizable: true },
        { field: 'uploadedTimestamp', width: 250,  headerName: 'Uploaded time', sortable: true, cellRenderer: epochToTimestamp, resizable: true },
        { field: '', headerName: 'Download uploaded file', width: 200, cellRenderer: downloadIcon }
    ])

    const defaultColDef = {
        // set filtering on for all columns
        filter: true,
        filterParams: {
            buttons: ["reset"],
            debounceMs: 200,
        },
    };

    const handleAccess = async (data) => {
        let resp = false
        if (data[PROCESS_KEYS.created_by] == userId) {
            resp = true
        } else {
            resp = await checkIfPortalAdmin(userId, currentStage)
            if(!resp){
                resp = await checkIfSupportAdmin(userId, currentStage)
            }
            
            if (!resp) {
                resp = await isUploaderAllowed(data, userId, currentStage)
            }
            if (!resp) {
                resp = await isApprover(data, userId, currentStage)
            }
        }

        setIsAuthorised(resp)
        setIsCheckingAccess(false)
    }

    const loadData = async () => {
        const pageLoadTime = createKatalTimerStopWatch("timeTaken")
        try {
        if (!lpid) {
            setShowLoadingIcon(false)
            return
        }
        
        setShowLoadingIcon(true)
        
            // First, get the Logico process from AppSync Plus
            const processResponse = await new Promise((resolve, reject) => {
                getLogicoProcessById(lpid, resolve, reject)
            })
            
            setProcessData(processResponse.data.getLogicoProcessByID)
            await handleAccess(processResponse.data.getLogicoProcessByID)
            
            // Switch to generic AppSync for DynamoDB transactions query
            await configureGenericAppSync()
            
            // Now fetch transactions from DynamoDB
            const transactions = await getLogicoTransactionsByLogicoProcessId(lpid)
            setTransactions(transactions)
            setShowLoadingIcon(false)
        } catch (error) {
            console.error('Error loading Logico data:', error)
            setShowLoadingIcon(false)
        } finally {
            if(!pageLoadTime.isStopped) {
            stopAndCaptureTimeMetricsWithBasicAttributes(pageLoadTime, userId, `${ln.pathname}${location.search}`,ACTION_METHODS.PAGE_LOAD_TIME , SITE_SERVICES.LOGICO)
            }
        }
    }

   

    const getParam= (key) => {
        const search = props?.location?.search;
        const params = new URLSearchParams(search);
        const value = params.get(key);
        return value;
      }

    
    const content = (
        <div>

            {
                isAuthorised?
                <Box>
                    <SpaceBetween size='l'>
            
                        <Container
                            header={
                                <Header
                                    variant='h2'
                                    actions={
                                        <SpaceBetween direction="horizontal" size="xs">

                                            <Button variant='normal' iconName='refresh' onClick={loadData}></Button>
                                        </SpaceBetween>
                                    }
                                    description="The following table shows all the files uploaded."
                                >File Uploads
                                    {showLoadingIcon ?
                                        <Spinner size='normal'></Spinner> : <div></div>
                                    }

                                </Header>
                            }
                            fitHeight
                        >
                            <div
                                className="ag-theme-alpine"
                                style={{ height: 400, width: "100%" }}
                            >
                                <AgGridReact
                                    ref={gridRef}
                                    rowData={transactions}
                                    defaultColDef={defaultColDef}
                                    columnDefs={columnDefs}
                                    rowSelection='single'
                                    animateRows={true}
                                    rowHeight={40}
                                    enableCellTextSelection={true}
                                    pagination={true}
                                    paginationPageSize={20}
                                    paginationPageSizeSelector={[10, 20, 50, 100]}
                                    suppressPaginationPanel={false}
                                >
                                </AgGridReact>
                            </div>
                         
                        </Container>
                    </SpaceBetween>
                    <Modal
                onDismiss={() => {
                    setVisible(false)
                    setLoadErrorData([])
                }}
                visible={visible}
                size="max"
                footer={
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button variant="primary" onClick={() => {
                                setVisible(false)
                                setLoadErrorData([])
                            }}>
                                Close
                            </Button>
                        </SpaceBetween>
                    </Box>
                }
            >
                

            </Modal>
                    </Box> : isCheckingAccess ? <div>
                        <WaitForPageAccess></WaitForPageAccess>
                    </div> :
                        <Alert
                            statusIconAriaLabel="Error"
                            type="error"
                            header="Access denied"
                        >
                            No access to view
                        </Alert>
            }
        </div>
    )


    return (
        <AppLayout
            content={content}
            navigation={<SideNav activeHref={`/App/${id}/LogicoProcess/${lpid}/history`} id={id} lpid={lpid} process={processData} back={backUrl}/>}
            headerSelector="#TopBar"
            navigationHide={props.disableAppLayout}
            disableBodyScroll={true}
            toolsHide={true}
            headerVariant="high-contrast"
        ></AppLayout>
    )
}



export default LogicoHistory
